import {Button, IconButton, Menu} from '@material-ui/core';
import {MoreVert} from '@material-ui/icons';
import classNames from 'classnames';
import React, {ReactNode, useMemo} from 'react';
import MenuStateProvider from 'Shared/components/MenuStateProvider';

type ActionsMenuProps = {
  id?: string;
  children: ((onClose: () => void) => JSX.Element) | ReactNode;
  className?: string;
  ariaLabel?: string;
  menuBtn?: 'button' | 'icon-button';
  menuBtnLabel?: React.ReactNode;
};

const ActionsMenu = ({id, className, ariaLabel, children, menuBtnLabel, menuBtn = 'icon-button'}: ActionsMenuProps) => {
  const menuBtnProps = useMemo(
    () => ({
      id,
      className: classNames('menu', className),
      'aria-label': ariaLabel ?? 'actions menu',
      'aria-haspopup': true,
    }),
    [id, className, ariaLabel]
  );

  return (
    <MenuStateProvider>
      {({anchor, close, open}) => (
        <>
          {menuBtn === 'icon-button' ? (
            <IconButton onClick={event => open(event.currentTarget)} {...menuBtnProps} aria-label={ariaLabel}>
              <MoreVert />
            </IconButton>
          ) : (
            <Button onClick={event => open(event.currentTarget)} {...menuBtnProps} aria-label={ariaLabel}>
              {menuBtnLabel}
            </Button>
          )}
          <Menu
            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            transformOrigin={{vertical: 'top', horizontal: 'center'}}
            getContentAnchorEl={null}
            onClose={close}
            open={Boolean(anchor)}
            anchorEl={anchor}
            onClick={close}
            role="menu"
          >
            {typeof children === 'function' ? children(close) : children}
          </Menu>
        </>
      )}
    </MenuStateProvider>
  );
};

export default ActionsMenu;
